module.exports = __webpack_public_path__ + "media/images/Groupe 151-08d654c01720f143963f04bbc7aca7af.svg";